import Vue from "vue";
import VueRouter from "vue-router";
import News from "../views/News.vue";
import NewsContent from "../components/news/NewsContent.vue";

Vue.use(VueRouter);

const Home = () => import("@/views/Home");
const Production = () => import("@/views/Production");
const ThreeNav = () => import("@/views/ThreeNav");
const FourNav = () => import("@/views/FourNav");
const FiveNav = () => import("@/views/FiveNav");
const Demo = () => import("@/views/Demo");
const KiddieRides = () =>
  import("@/components/1_kiddie_rides/ProductionBrain.vue");
const ParentChild = () => import("@/components/2_parent_child/ProductionBrain.vue");
const PrizeMachines = () => import("@/components/3_prize_machines/ProductionBrain.vue");
const RedemptionGames = () => import("@/components/4_redemption_games/ProductionBrain.vue");
const Simulators = () => import("@/components/5_simulators/ProductionBrain.vue");
const SportGanmes = () => import("@/components/6_sports_games/ProductionBrain.vue");
const ProjectGames = () => import("@/components/7_projector_games/ProductionBrain.vue");
const VRGames = () => import("@/components/8_vr_games/ProductionBrain.vue");
const Others = () => import("@/components/9_others/ProductionBrain.vue");
const ProductDetail = () => import("@/components/0_product_details/ProductionBrain.vue");
const ReportList = () => import("@/components/report_list/index.vue");
const NewsDetails = () => import("@/components/report_list/NewsDetails.vue");
const CompanyIntroduction = () => import("@/components/company_introduction/index.vue");
const ContractUs = () => import("@/components/contract_us/index.vue");

const routes = [
  {
    path: "",
    redirect: "/home",
  },
  {
    path: "/home",
    redirect: "/home/index",
  },
  {
    path: "/home/index",
    component: Home,
  },
  {
    path: "/production",
    component: Production,
    children: [
      {
        path: "1",
        component: KiddieRides,
      },
      {
        path: "2",
        component: ParentChild,
      },
      {
        path: "3",
        component: PrizeMachines,
      },
      {
        path: "4",
        component: RedemptionGames,
      },
      {
        path: "5",
        component: Simulators,
      },
      {
        path: "6",
        component: SportGanmes,
      },
      {
        path: "7",
        component: ProjectGames,
      },
      {
        path: "8",
        component: VRGames,
      },
      {
        path: "9",
        component: Others,
      },
      {
        path: "detail",
        component: ProductDetail,
      }
    ],
  },
  {
    path: "/threenav",
    component: ThreeNav,
  },
  {
    path: "/threenav/index",
    component: ThreeNav,
  },
  {
    path: "/fournav",
    component: FourNav,
    children: [
      {
        path: "1",
        component: ReportList,
      },
      {
        path: "2",
        component: ReportList,
      },
      {
        path: "3",
        component: ReportList,
      },
    ],
  },
  {
    path: "/fivenav",
    component: FiveNav,
    children: [
      {
        path: "1",
        component: CompanyIntroduction,
      },
      {
        path: "2",
        component: ContractUs,
      },
      {
        path: "3",
        component: CompanyIntroduction,
      },
      {
        path: "4",
        component: CompanyIntroduction,
      },
    ],
  },
  {
    path: "/demo",
    component: Demo,
  },
  {
    path: "/news_detail/:id",
    component: NewsDetails,
  },
  {
    path: "/news",
    component: News,
    children: [
      {
        path: "content",
        component: NewsContent,
      },
    ],
  },

];

const router = new VueRouter({
  mode: "hash",
  routes,
});

export default router;
